import { authService } from '@/services/authService.js';
import { authTokenService } from '@/services/authTokenService.js';
import Admin from '@/views/Admin.vue';
import ChangePassword from '@/views/ChangePassword.vue';
import Home from '@/views/Home.vue';
import Landing from '@/views/Landing.vue';
import AdminContainer from '@/views/AdminContainer.vue';
import OfficeManagement from '@/views/OfficeManagement.vue';
import OfficeContact from '@/views/OfficeContact.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import ForgotPassword from '@/views/ForgotPassword.vue';
import Register from '@/views/Register.vue';
import SurveySubmit from '@/views/SurveySubmit.vue';
import SurveySubmitted from '@/views/SurveySubmitted.vue';
import EnlistOthers from '@/views/EnlistOthers.vue';
import Unavailable from '@/views/Unavailable.vue';
import Unavailable_ from '@/views/Unavailable_.vue';
import Vue from 'vue';
import Router from 'vue-router';
import ReportingUnits from '@/views/ReportingUnits.vue';
import SubOfficeAggregation from '@/views/SubOfficeAggregation.vue';
import AdminDataCollectionStats from '@/components/admin/AdminDataCollectionStats.vue';
import AdminDataCollectionView from '@/components/admin/AdminDataCollectionView.vue';
import AdminProgressReport from '@/components/admin/AdminProgressReport.vue';
import AdminOfficeDetails from '@/components/admin/AdminOfficeDetails.vue';
import AdminOfficeSearch from '@/components/admin/AdminOfficeSearch.vue';
import DataCollectionStatsContainer from '@/components/admin/DataCollectionStatsContainer.vue';
import AllOfficeDataCollectionStats from '@/components/admin/AllOfficeDataCollectionStats.vue';
import Reports from '@/components/admin/Reports.vue';
import ReportMain from '@/components/admin/ReportMain.vue';
import ReportDetail from '@/components/admin/ReportDetail.vue';
import Report100M from '@/components/admin/Report100M.vue';
import Report100MDetail from '@/components/admin/Report100MDetail.vue';
import ReportNatPat from '@/components/admin/ReportNatPat.vue';
import AdminSupportDetailsContainer from '@/components/admin/AdminSupportDetailsContainer.vue';
import AdminPeopleSearch from '@/components/admin/AdminPeopleSearch.vue';
import AdminCodeBookSearch from '@/components/admin/AdminCodeBookSearch.vue';
import AdminSearchContainer from '@/components/admin/AdminSearchContainer.vue';
import SupportRequest from '@/components/admin/support/SupportRequest.vue';
import SupportRequestSummary from '@/components/admin/support/SupportRequestSummary.vue';
import AdminManageOffices from '@/components/admin/AdminManageOffices.vue';
import AdminAddNewOffice from '@/components/admin/AdminAddNewOffice.vue';
import ProgressMonitorSub from '@/views/ProgressMonitor.vue';

Vue.use(Router);

// All routes require an auth token unless marked meta.guest = true

let router = new Router({
	routes: [
		{
			path: '/survey',
			alias: '/Q*',
			name: 'home',
			component: Home
		},
		{
			path: '/landing',
			name: 'landing',
			component: Landing
		},
		{
			path: '/changepassword',
			name: 'changepassword',
			component: ChangePassword
		},
		{
			path: '/resetpassword',
			name: 'resetpassword',
			component: ResetPassword,
			meta: {
				guest: true
			}
		},
		{
			path: '/forgotpassword',
			name: 'forgotpassword',
			component: ForgotPassword,
			meta: {
				guest: true
			}
		},
		{
			path: '/register',
			name: 'register',
			component: Register,
			meta: {
				guest: true
			}
		},
		{
			path: '/officemanagement',
			name: 'officemanagement',
			component: OfficeManagement
		},
		{
			path: '/',
			alias: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
			meta: {
				guest: true
			}
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
		},
		{
			path: '/officecontact',
			name: 'officecontact',
			component: OfficeContact
		},
		{
			path: '/surveysubmit',
			name: 'surveysubmit',
			component: SurveySubmit
		},
		{
			path: '/surveysubmitted',
			name: 'surveysubmitted',
			component: SurveySubmitted
		},
		{
			path: '/enlistothers',
			name: 'enlistothers',
			component: EnlistOthers
		},
		{
			path: '/unavailable',
			name: 'unavailable',
			component: Unavailable
		},
		{
			path: '/unavailable_',
			name: 'unavailable_',
			component: Unavailable_
		},
		{
			path: '/reportingunits',
			name: 'reportingunits',
			component: ReportingUnits
		},
		{
			path: '/officeaggregation',
			name: 'officeaggregation',
			component: SubOfficeAggregation
		},
		{
			path: '/progressmonitor',
			name: 'progressmonitor',
			component: ProgressMonitorSub
		},
		{
			path: '/admin',
			// name: 'admin',
			component: AdminContainer,
			children: [
				{
					path: '',
					name: 'admin.stats',
					component: AdminDataCollectionStats
				},
				{
					path: 'progressreport',
					name: 'admin.progress',
					component: AdminProgressReport
				},
				{
					path: '/view/:type/:id',
					name: 'admin.viewstats',
					component: DataCollectionStatsContainer
				},
				{
					path: 'details/:id/:surveyId',
					name: 'details',
					component: AdminOfficeDetails
				},
     			{
					path: 'search',
					name: 'admin.search',
					component: AdminSearchContainer,
					children: [{
						path: 'office',
						name: 'admin.search.office',
						component: AdminOfficeDetails
					},
					{
						path: 'people',
						name: 'admin.search.people',
						component: AdminPeopleSearch
					},
					{
						path: 'codebook',
						name: 'admin.search.codebook',
						component: AdminCodeBookSearch
					}]
				},
				{
					path: 'officesearch/:id',
					name: 'admin.search',
					component: AdminOfficeDetails
				},
				{
					path: 'peoplesearch/:id',
					name: 'admin.peoplesearch',
					component: AdminPeopleSearch
				},
				{
					path: 'allstats',
					name: 'admin.allstats',
					component: AllOfficeDataCollectionStats
				},
				{
					path: 'support',
					name: 'admin.support',
					component: AdminSupportDetailsContainer
				},
				{
					path: 'manageoffices',
					name: 'admin.manageoffices',
					component: AdminManageOffices
				},
				{
					path: 'addnewoffice',
					name: 'admin.addnewoffice',
					component: AdminAddNewOffice
				},
				{
					path: 'reports/reportdetails',
					name: 'admin.reportdetails',
					component: Report100M
				},
				{
					path: 'reports/reportrecords',
					name: 'admin.report100mdetail',
					component: Report100MDetail
				},
				{
					path: 'reports/reportnatpat',
					name: 'admin.reportNatPat',
					component: ReportNatPat
				},
				{
					path: 'support/request',
					name: 'admin.supportRequest',
					component: SupportRequest
				},
				{
					path: 'support/request/summary',
					name: 'admin.supportRequestSummary',
					component: SupportRequestSummary
				},
				{
					path: '/register',
					name: 'register',
					component: Register
				}
			]
		}
	]
});

// Check for an auth token before proceeding to the next route.
router.beforeEach((to, from, next) => {
	if (authService.isAuthenticated()) {
		if (authTokenService.isAdmin() && (from.name === 'login' && to.name === 'landing')) {
			next({ path: '/admin' });
		} else {
			// If the user has a token continue to destination
			next();
		}
		// If we introduce role specific pages add checks here
	} else if (to.matched.some(record => record.meta.guest)) {
		// If the user does not have a token but is accessing a route that allows guests, continue
		next();
	} else {
		console.log('No token found. Redirecting to login page.');
		// User does not have a token and is attempting to access a non guest page
		// Redirect the user to the login page
		next({
			path: '/login',
			params: { nextUrl: to.fullPath }
		});
	}
});

export default router;
